/* eslint-disable */
import React, { useEffect, useState } from "react";
import { message, Modal, Button } from 'antd';
import { Navigate, Route, Routes, Redirect } from "react-router-dom";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
// import { useLocation } from "react-router-dom";
import { docTitleDict } from "@/utils/dict";
import routerList from "@/router";
import { useNavigate, useLocation } from 'react-router-dom';
// 公共组件
import Login from "@/views/Login";
import Nopermission from "@/views/Nopermission";
export default function IndexRouter() {
  const [loading, setLoading] = useState(false);
  const [codeFlag, setCodeFlag] = useState(false);
   const navigate = useNavigate();
  const { hash } = window.location; 

  const location = useLocation();
  useEffect(() => {
    const noLoginToken = new URLSearchParams(location.search).get("token")
    if (noLoginToken) {
      noPasswordLoginFn(noLoginToken);
      // http://localhost:3000/#/MaintenanceRequest/Maintenance?token=IapRdDubBcAFo9g1pOB8Rg%2F7tjtONtnx%2BpgivoEAwjGjCO9zvWrC7jBZPetz76cVQeLtTdOjoJoilnQKbiDUhQ%3D%3D
    }
    // 设置别名
    setDocTitlefn(location)
  }, [location]);

  const setDocTitlefn = (location) => {
    const url = location.pathname.split('?')[0]
    const list =  Object.keys(docTitleDict).filter(item => url === item) || []
    if(list.length){
      document.title = docTitleDict[list[0]];
    } else {
      document.title = 'DataWorkers';
    }
  }

  //获取用户信息
  const noPasswordLoginFn = async (token) => {
    getLoginDataFn(api.noLogin, {token: decodeURIComponent(token)}, false)
  };

const passwordLoginFn = async(params) => {
  getLoginDataFn(api.getLogin, params, true)
}

// const getLoginDataFn = async(apiUrl, params, flag) => {
//   setLoading(true);
//   const response = await http.post(apiUrl, params);
//   if (response.code === "1") {
//     if(flag) {
//       message.success("Login successfully");
//     }
//     setCodeFlag(false)
//     commonFn.initLoginDataFn(response.data)
//   } else {
//     if(response.msg === "An email verification code is required."){
//       setCodeFlag(true)
//     }
//     commonFn.modalFailedFn(response)
//   }
//   setLoading(false);
// }

// router 重定向
  const getRedirectFromHash = () => {
    const query = window.location.hash.includes('?') ? window.location.hash.split('?')[1] : '';
  const p = new URLSearchParams(query);
  const r = p.get('redirect');
  return r ? decodeURIComponent(r) : null;
  };

const getLoginDataFn = async (apiUrl, params, flag) => {
  setLoading(true);
  try {
    const res = await http.post(apiUrl, params);
    if (res.code === '1') {
       sessionStorage.removeItem('expectedMenu');
      if (flag) message.success('Login successfully');
      setCodeFlag(false);
      commonFn.initLoginDataFn(res.data);

      // URL 优先 -> sessionStorage -> 默认
      const fromUrl = getRedirectFromHash();
      const fromStore = sessionStorage.getItem('redirectPath') || '';
      let target = fromUrl || fromStore || '/home/index';


      const isInternal =
        typeof target === 'string' &&
        target.startsWith('/') &&
        !target.startsWith('//');

      if (!isInternal) target = '/home/index';

      // 不回到登录/无权限页
      if (target.startsWith('/login') || target.startsWith('/Nopermission')) {
        target = '/home/index';
      }

      // 清除一次性 redirect 信息，避免后续污染
      sessionStorage.removeItem('redirectPath');

      //  用 Router 导航 + replace，避免历史回退回到 /login
      navigate(target, { replace: true });
      return;
    }

    // 失败分支
    if (res.msg === 'An email verification code is required.') setCodeFlag(true);
    commonFn.modalFailedFn(res);
  } catch (e) {
    console.error('login error', e);
  } finally {
    setLoading(false);
  }
};




  const renderRouteFn = (routeList) => {
    if (!Array.isArray(routeList)) return null;
    return routeList.map((route) => {
      const routeChild =
        (route?.children && renderRouteFn(route.children)) || null;
      return (
        <Route key={route.path} path={route.path} element={route.element}>
          {routeChild}
        </Route>
      );
    });
  };

  return (
    <Routes>
      {routerList.map(route => renderRouteFn(route))}
      {/* 默认页面 */}
      <Route path="/login" element={
        <Login 
          loading={loading}
          passwordLoginFn={passwordLoginFn}
          codeFlag={codeFlag}
        />
      } />
      <Route path="/Nopermission" element={<Nopermission />} />
      <Route path="*" element={<Navigate to={localStorage.getItem("tokenPC") ? '/home/index' :'/login'} replace />} />
    </Routes>
  );
}
